import React, { useEffect, useState } from "react";
import cautionIcon from "./caution_Icon.png";

const FloatingIconWithPopup = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    // Check if this is the user's first visit
    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      setIsFirstVisit(true);
      // Set flag in localStorage to mark the visit
      localStorage.setItem("hasVisited", "true");
      // Automatically hide the popup after 1 minute (60,000 ms)
      const timer = setTimeout(() => {
        setIsFirstVisit(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsVisible(false); // Hide component when scrolling starts
      } else {
        setIsVisible(true); // Show component when back at the top
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Conditionally render the component based on isVisible
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Floating Icon */}
      <div
        className="relative w-12 h-12 border border-red-600 bg-white rounded-full flex items-center justify-center   transition-colors duration-300"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="cursor-pointer">
          <img
            src={cautionIcon}
            alt="Caution Icon"
            className="w-8 h-8 object-contain"
          />
        </div>

        {/* Popup Card - Shown on hover or during first visit */}
        {(isHovered || isFirstVisit) && (
          <div className="absolute bottom-14 right-0 w-[90vw] sm:w-[310px] max-w-[310px]  bg-white shadow-lg rounded-[18px]  border border-red-500 p-4 transform transition-all duration-300 ease-in-out scale-100 motion-safe:animate-slideIn">
            <div className="flex items-center justify-center  space-x-1 border-b border-gray-300 pb-2">
              <svg
                className="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2L1 21h22L12 2zm0 4.5l8 14h-16l8-14zm-1 3h2v6h-2v-6zm1 8.5a1 1 0 100-2 1 1 0 000 2z" />
              </svg>
              <h3 className="text-lg font-medium text-[#6E6E6E]">Alert</h3>
            </div>
            <p className="text-md font-normal text-[#6E6E6E] mt-3 text-center leading-tight">
              We never request payments via cryptocurrency. If asked, report
              immediately to our support team.
            </p>
            <p className="text-sm text-center text-[#6E6E6E] mt-2 leading-tight font-bold">
              Stay safe!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingIconWithPopup;
